import { fetchGet, fetchPost } from "@/lib/services";

export async function getDeliveryBoyDetailsService(username: string) {
  return await fetchGet(`/loginimage/?Username=${username}`);
}

export async function loginDeliveryPersonForDay(formData: FormData) {
  return await fetchPost("/loginimage/", formData, true);
}

export async function getDeliveryPickUps(branchCode?: string, zoneCode?: string) {
  return await fetchGet(`/Pickups/?${branchCode ? `Branch_Code=${branchCode}&` : ""}${zoneCode ? `Zone_Code=${zoneCode}&` : ""}pickups=true`);
}

export async function getPickupsSummary(branchCode?: string, zoneCode?: string) {
  return await fetchGet(`/Pickups/?${branchCode ? `Branch_Code=${branchCode}&` : ""}${zoneCode ? `Zone_Code=${zoneCode}&` : ""}`);
}

export async function pickUpFromParentHome(formData: FormData) {
  return await fetchPost("/parent-deliveries/", formData, true);
}

export async function submitAtSchool(formData: FormData) {
  return await fetchPost("/school-deliveries/", formData, true);
}

export async function getSchoolsForDelivery(stateCode: string, cityCode: string) {
  return await fetchGet(`/states_citiesdata/?State_Code=${encodeURIComponent(stateCode)}&City_Code=${encodeURIComponent(cityCode)}`);
}

export async function getDeliveryLocation(username: string) {
  return await fetchGet(`/update-location/?username=${username}`);
}

export async function getDeliveryLocationHistory(username: string) {
  return await fetchGet(`/update-location/?username=${username}&tracking=history`);
}

export const getParentsService = async (params?: string) => {
  return await fetchGet(`/parents/${params ? `?${params}` : ""}`);
};

export const getDeliveryEmployeesService = async (params?: string) => {
  return await fetchGet(`/branch-zone-employees/?${params}`);
};

export const getAssignmentsService = async (params?: string) => {
  return await fetchGet(`/assign-delivery/${params ? `?${params}` : ""}`);
};

export const createAssignmentService = async (payload: any) => {
  return await fetchPost(`/assign-delivery/`, payload);
};